module.exports = __webpack_public_path__ + "media/images/account-multiple-43c1767e778bc41f0f71fd51892431f4.svg";